import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import PaginationTable from '../../PaginationTable';
import {formatDatetime, formatFloat, numberPadding } from '../../../../utils/formatting';
import _ from 'lodash';

export default class AccompanimentExecutive extends React.Component {

    constructor(props) {
        super(props);
        this.showDetail = this._showDetail.bind(this);
        this.hideDetail = this._hideDetail.bind(this);
        this.state = {
            showDetailFor : null
        }
    }

    _showDetail(report) {
        this.setState({
            showDetailFor : report,
        });
    }

    _hideDetail() {
        this.setState({
            showDetailFor : null,
        });
    }


    render() {
        const report = this.state.showDetailFor;
        return (
            <div>
                <div className="table-responsive">
                    <PaginationTable
                    territories={this.props.territories}
                    coordinations={this.props.coordinations}
                    {...this.props.data}
                    showDetail={this.showDetail}
                    pageChange={this.props.changePage}
                    headerComponent={renderHeader}
                    rowComponent={renderRow}/>
                </div>

                <Modal isOpen={report !== null} toggle={this.hideDetail} bsSize="large">
                    <ModalHeader toggle={this.hideDetail}>
                        Reporte de acompañamiento Broker
                    </ModalHeader>

                    <ModalBody>
                        {
                            report != null ? 
                            <div>
                                <legend>
                                    Gestión en plaza
                                </legend>
                                <table className="table">
                                    <tbody>
                                        <tr className="table-active">
                                            <th colSpan={3}>
                                                1. Revisión ficha de sus principales clientes                   
                                            </th>
                                        </tr>
                                        <tr className="table-active">
                                            <th colSpan={3}>
                                                <small>1.1 Cartera de Crédito</small>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>
                                                ¿Cuántos prospectos nuevos tienes de cartera y sus montos?
                                            </td>
                                            <td>
                                                {report.prospectos_nuevos}
                                            </td>
                                            <td>
                                                {formatFloat(report.prospectos_nuevos_monto)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                ¿Cuántos prospectos haz contratado? (% de conversión)
                                            </td>
                                            <td>
                                                {report.prospectos_contratados}
                                            </td>
                                            <td>
                                                {formatFloat(report.prospectos_contratados_monto)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                ¿Cuánto falta para cumplir la meta?
                                            </td>
                                            <td colSpan={2}>
                                                {report.faltante_meta}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                ¿Cúal es la estrategia para cubrir gaps?
                                            </td>
                                            <td colSpan={2}>
                                                {report.estrategia_meta}
                                            </td>
                                        </tr>
                                        <tr className="table-active">
                                            <th colSpan={3}>
                                                <small>1.2 Captación</small>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>
                                                Revisión de principales clientes que salieron de la cartera
                                            </td>
                                            <td>
                                                {report.clientes_fuera}
                                            </td>
                                            <td>
                                                {formatFloat(report.clientes_fuera_monto)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                ¿Cómo se va a cubrir la diferencia?
                                            </td>
                                            <td colSpan={2}>
                                                {report.estrategia_dif}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                ¿Cúal es la estrategia de retencion de clientes?
                                            </td>
                                            <td colSpan={2}>
                                                {report.estrategia_retencion}
                                            </td>
                                        </tr>
                                        <tr className="table-active">
                                            <th colSpan={3}>
                                                2. Campaña de crédito
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>
                                                ¿Cuántos prospectos tienes y cuáles son los montos?
                                            </td>
                                            <td>
                                                {report.prospectos_cred}
                                            </td>
                                            <td>
                                                {formatFloat(report.prospectos_cred_monto)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                ¿Cuántos prospectos haz contratado? (% de conversión)
                                            </td>
                                            <td>
                                                {report.prospcred_contratados}
                                            </td>
                                            <td>
                                                {formatFloat(report.prospcred_contratados_monto)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                ¿Cúal es la estrategia para colocar el restante?
                                            </td>
                                            <td colSpan={2}>
                                                {report.credestrategia_dif}
                                            </td>
                                        </tr>
                                        <tr className="table-active">
                                            <th colSpan={3}>
                                                3. Comunicación Negocio (Banca PyME)
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>
                                                Despliegue de comunicados del mes
                                            </td>
                                            <td>
                                                {report.comunicados}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Cuestionarios
                                            </td>
                                            <td>
                                                {report.cuestionarios}
                                            </td>
                                        </tr>
                                        

                                    </tbody>
                                </table>

                                <legend>
                                    Visita a cliente con un asesor
                                </legend>
                                <table className="table">
                                    <tbody>
                                        <tr className="table-active">
                                            <th colSpan={3}>
                                                1. Preparación de visita                    
                                            </th>
                                        </tr>
                                        <tr>
                                            <td rowSpan={2}>
                                                ¿El asesor preparó adecuadamente la visita?
                                            </td>
                                            <td>
                                                {report.preparo_visita ? 'Sí' : 'No'}
                                            </td>
                                            <td>
                                                {report.preparo_visita_porque}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                {report.preparo_visita_comments}
                                            </td>
                                        </tr>
                                        <tr className="table-active">
                                            <th colSpan={3}>
                                                2. Calificación de visita
                                            </th>
                                        </tr>
                                        <tr>
                                            <td rowSpan={2}>
                                                ¿Supo como romper el hielo con el cliente?
                                            </td>
                                            <td>
                                                {report.romper_hielo ? 'Sí' : 'No'}
                                            </td>
                                            <td>
                                                {report.romper_hielo_porque}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                {report.romper_hielo_comments}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td rowSpan={2}>
                                                ¿Generó compromisos con el cliente?
                                            </td>
                                            <td>
                                                {report.hizo_compromiso ? 'Sí' : 'No'}
                                            </td>
                                            <td>
                                                {report.hizo_compromiso_porque}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>
                                                {report.hizo_compromiso_comments}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Calificación general de la visita
                                            </td>
                                            <td colSpan={2}>
                                                {report.calificacion}
                                            </td>
                                        </tr>

                                        <tr className="table-active">
                                            <th colSpan={3}>
                                                3. Comentarios al Broker
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>
                                                Retroalimentación al asesor de la visita realizada
                                            </td>
                                            <td colSpan={2}>
                                                {report.feedback}
                                            </td>
                                        </tr>
                                        <tr className="table-active">
                                            <th colSpan={3}>
                                                4. Seguimiento en redes sociales
                                            </th>
                                        </tr>
                                        {
                                            ['facebook', 'linkedin', 'twitter'].map(red => (
                                                report['redes_'+ red] ?
                                                <tr key={red}>
                                                    <td>
                                                        {_.upperFirst(red)}
                                                    </td>
                                                    <td colSpan={2}>
                                                        {report['redes_'+ red]}
                                                    </td>
                                                </tr>
                                                : null
                                            ))
                                        }
                                        <tr>
                                            <td>
                                                Comentarios
                                            </td>
                                            <td colSpan={2}>
                                                {report.redes_comments}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                ¿Por qué medio se mantendrá el contacto con el cliente?
                                            </td>
                                            <td colSpan={2}>
                                                {report.medio_contacto}
                                            </td>
                                        </tr>
                                        
                                        
                                        
                                    </tbody>
                                </table>
                            </div>

                            : null
                        }
                        
                    </ModalBody>
                </Modal>
            </div>
            
        );
    }
}

function renderHeader(props) {
    return (
        <tr>
            <th>Fecha</th>
            <th>Título cita</th>
            <th>Número empleado</th>
            <th>Asesor</th>
            <th>Calificación</th>
            <th>Detalle</th>
        </tr>
    );
}

function renderRow(props) {
    const {item} = props;
    return (
        <tr>
            <td>
                {formatDatetime(item.event.datetime)}
            </td>
            <td>
                {item.event.title}
            </td>
            <td>
                {numberPadding(item.event.target.emp_number, 6)}
            </td>
            <td>
                {item.event.target.name}
            </td>
            <td>
                {item.calificacion}
            </td>
            <td>
                <button className="btn btn-sm btn-primary" onClick={() => props.showDetail(item)}>Detalle</button>
            </td>
        </tr>
    );
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/reports/accompaniment/AccompanimentExecutive.jsx
 **/